// Module
var code = `<div class="card">
    <div class="card-header" ng-click="ctrl.isCollapsed = !ctrl.isCollapsed" style="cursor: pointer;">
		<span class="card-title h4">
			<i class="fas fa-fw" ng-class="{'fa-chevron-right': ctrl.isCollapsed, 'fa-chevron-down': !ctrl.isCollapsed}"></i>
			<i class="fas fa-users"></i>
			<span>Social Media</span>
		</span>
	</div>

	<div ng-show="!ctrl.isCollapsed">
		<empty-info ng-show="ctrl.SocialMediaSources.length === 0" no="Social Media"></empty-info>
		<div class="flex-media-library" ng-show="ctrl.SocialMediaSources.length > 0">
			<div class="flex-media-item" ng-repeat="item in ctrl.SocialMediaSources | orderBy:'filter'">
				<bulk-select class="header" title="{{item.filter}}" media-title="item.filter"
					on-toggle="ctrl.toggleBulk(item.id)"></bulk-select>
				<div class="content">
					<div class="thumb center-center text-muted" style="border: 0;">
						<i ng-if="item.type === 'InstagramFreetext'" class="fas fa-font fa-5x"></i>
						<i ng-if="item.type === 'InstagramHashtag'" class="fas fa-hashtag fa-5x"></i>
						<i ng-if="item.type === 'InstagramUsername'" class="fab fa-instagram fa-5x"></i>
						<i ng-if="item.type === 'InstagramMention'" class="fas fa-at fa-5x"></i>
					</div>
					<div class="controls">
						<div class="d-grid" ng-if="ctrl.scene">
							<button class="btn btn-sm btn-outline-primary" type="button"
								ng-click="ctrl.addToScene(item.id)"
								ng-disabled="!ctrl.isSceneActive()">
								<i class="fas fa-plus-circle"></i> Add to playlist
							</button>
						</div>
						<div>
							<span>Post last fetched at</span>
							<!-- <span>{{item.lastUpdate | amAdd : '2' : 'hours' | amDateFormat:'YYYY-MM-DD HH:mm:ss'}}</span> -->
							<span>{{item.lastUpdate | amUtc | amLocal | amDateFormat:'YYYY-MM-DD HH:mm:ss'}}</span>
							<!--TODO: Figure out how to handle the timezone difference-->
						</div>
						<div>
							<span>Type:</span>
							<span ng-if="item.type === 'InstagramFreetext'">Instagram Freetext</span>
							<span ng-if="item.type === 'InstagramHashtag'">Instagram Hashtag</span>
							<span ng-if="item.type === 'InstagramUsername'">Instagram Username</span>
							<span ng-if="item.type === 'InstagramMention'">Instagram Mention</span>
						</div>
						<div>
							<media-labels social-media-id="item.id"></media-labels>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</div>
`;
// Exports
export default code;